import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';
import { OptionElement } from 'src/domains/layouts/shared/formComponents/Select/SelectNative.style';
import { SelectNative } from 'src/domains/layouts/shared/formComponents/Select/SelectNative';
import { CasinoGamesSelectState } from 'src/domains/layouts/shared/formComponents/Select/casinoSelectGames/SelectCasinoStateGames.state';

interface SelectOptionsType {
    key: string;
    name: string;
}

interface CasinoGamesSelectPropsType {
    className?: string;
    dataTest?: string;
    onChangeCB?: (value: string) => void;
    defaultText?: string;
    selectOptions: Array<SelectOptionsType>;
    stateValue: FormInputState<string | string, string>;
    title?: string;
}

/**
 * @deprecated - Please use Select from 'src/domains/layouts/shared/formComponents/Select/components/Select.tsx' instead
 * (change redirect_game type to string instead of string | number in BE - look up Headline Carousel)
 */

export const CasinoGamesSelect = observer(
    'CasinoGamesSelect',
    ({
        className,
        title,
        dataTest,
        selectOptions,
        stateValue,
        onChangeCB,
        defaultText,
    }: CasinoGamesSelectPropsType) => {
        const [state] = useState(() => new CasinoGamesSelectState(stateValue, onChangeCB));

        return (
            <>
                {title === undefined ? null : <Label>{title}</Label>}

                <SelectNative
                    className={className}
                    dataTest={dataTest}
                    onChange={state.onChange}
                    value={stateValue.value}
                >
                    {selectOptions.length > 0 && (
                        <>
                            {defaultText === undefined ? null : (
                                <OptionElement
                                    defaultValue={defaultText}
                                    value=''
                                    disabled
                                    hidden
                                >
                                    {defaultText}
                                </OptionElement>
                            )}
                            {selectOptions.map(({ key, name }: SelectOptionsType) => (
                                <OptionElement
                                    key={key}
                                    value={key}
                                >
                                    {name}
                                </OptionElement>
                            ))}
                        </>
                    )}
                </SelectNative>
            </>
        );
    }
);
